import { createContext, useContext } from 'react'

/**
 * Per-slot context providing whether the enclosing TabSlot is the active tab.
 *
 * Replaces the previous `isActive` prop that flowed through `TabContent` into
 * every page component. Prop-drilling forced `React.memo(TabContent)` to
 * re-render on every tab switch — including for inactive slots — which
 * cascaded through the page's entire subtree (TaskBoard → DndContext →
 * SortableContext → TaskList, etc.).
 *
 * With a context, only components that explicitly call `useIsActiveTab()`
 * re-subscribe. The rest of the page subtree memoizes as usual.
 */
const ActiveTabContext = createContext<boolean>(true)

export const ActiveTabProvider = ActiveTabContext.Provider

export function useIsActiveTab(): boolean {
  return useContext(ActiveTabContext)
}
